import {
    Component, ViewEncapsulation, OnDestroy, OnInit, Input, EventEmitter, Output
} from '@angular/core';

import { Subscription } from 'rxjs';

import { ProgressService } from '../../services/progress/progress.service';

@Component({
    selector: 'emq-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit, OnDestroy {

    @Input()
    public type = 'button';

    @Input()
    public ngStyleClass: any;

    @Input()
    public tabIdx?: number;

    @Input()
    public styleClass = '';

    @Input()
    public disabled = false;

    @Input()
    public disableProgress = false;

    @Output()
    public onClick: EventEmitter<any> = new EventEmitter();

    private sub?: Subscription;

    public isInProgress = false;

    public onClickEvent() {
        this.onClick.emit(null);
    }


    constructor(
        private $progressService: ProgressService
    ) { }

    ngOnInit() {

        this.sub = this.$progressService.getStateChange().subscribe(result => {
            if (result && this.disableProgress !== true) {
                this.isInProgress = result.inProgress;
            }
        });

    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
